export default "__VITE_ASSET__347db76d__"